var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxConsultancy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tax_consultancy",
    transform: "translate(-0.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6107",
    "data-name": "Group 6107",
    transform: "translate(91.961 46.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6106",
    "data-name": "Group 6106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4951",
    "data-name": "Path 4951",
    d: "M317.386,157.906l-.127-.021a2.93,2.93,0,1,0-.928,5.785l.1.017a2.93,2.93,0,1,0,.952-5.781Z",
    transform: "translate(-313.865 -157.848)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6109",
    "data-name": "Group 6109",
    transform: "translate(0.008 33.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6108",
    "data-name": "Group 6108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4952",
    "data-name": "Path 4952",
    d: "M147.024,163.749a8.76,8.76,0,0,0-12.374,0,2.93,2.93,0,0,0,4.144,4.143,2.893,2.893,0,0,1,4.087,0,4.349,4.349,0,0,1,0,6.144,6.163,6.163,0,0,1-8.716,0l-.006-.005c.02-.563.034-1.127.034-1.693a46.4,46.4,0,0,0-27.208-42.185,2.93,2.93,0,1,0-2.418,5.337,40.443,40.443,0,0,1,5.188,70.868,2.93,2.93,0,0,0-1.344,2.464v13.925a1.76,1.76,0,0,1-1.758,1.758H92.589a1.76,1.76,0,0,1-1.758-1.758v-5.771a4.213,4.213,0,0,0-4.208-4.208H56.367a4.213,4.213,0,0,0-4.209,4.208v5.771a1.76,1.76,0,0,1-1.758,1.758H36.337a1.76,1.76,0,0,1-1.758-1.758V208.823a2.93,2.93,0,0,0-1.344-2.463,40.412,40.412,0,0,1-17.11-23.2,2.932,2.932,0,0,0-3.649-2.029H9.667a3.8,3.8,0,0,1-3.8-3.8v-9.979a3.8,3.8,0,0,1,3.8-3.8h2.846a2.931,2.931,0,0,0,3.612-2.039,40.465,40.465,0,0,1,36.039-29.5,2.93,2.93,0,1,0-.417-5.845,45.989,45.989,0,0,0-8.179,1.337,17.546,17.546,0,0,0-17.126-13.839H25.327a2.93,2.93,0,0,0-2.93,2.93v22.983A46.157,46.157,0,0,0,11.166,157.69h-1.5a9.67,9.67,0,0,0-9.659,9.659v9.979a9.67,9.67,0,0,0,9.659,9.659h1.5a46.258,46.258,0,0,0,17.551,23.4v12.359a7.626,7.626,0,0,0,7.617,7.617H50.4a7.626,7.626,0,0,0,7.617-7.617v-4.12H84.972v4.12a7.626,7.626,0,0,0,7.617,7.617h14.063a7.626,7.626,0,0,0,7.617-7.617V210.388a46.1,46.1,0,0,0,19.188-29.8,12.042,12.042,0,0,0,13.567-2.408A10.215,10.215,0,0,0,147.024,163.749ZM28.257,119.666a11.685,11.685,0,0,1,9.694,9.674,46.355,46.355,0,0,0-9.694,5.288Z",
    transform: "translate(-0.008 -113.665)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6111",
    "data-name": "Group 6111",
    transform: "translate(30.249 72.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6110",
    "data-name": "Group 6110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4953",
    "data-name": "Path 4953",
    d: "M108.229,246.988a2.928,2.928,0,1,0,.858,2.071A2.94,2.94,0,0,0,108.229,246.988Z",
    transform: "translate(-103.228 -246.13)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6113",
    "data-name": "Group 6113",
    transform: "translate(52.955 62.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6112",
    "data-name": "Group 6112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4954",
    "data-name": "Path 4954",
    d: "M216.928,213H183.658a2.93,2.93,0,1,0,0,5.859h33.271a2.93,2.93,0,1,0,0-5.859Z",
    transform: "translate(-180.728 -213)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6115",
    "data-name": "Group 6115",
    transform: "translate(56.992 25.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6114",
    "data-name": "Group 6114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4955",
    "data-name": "Path 4955",
    d: "M210.036,86.593a15.527,15.527,0,1,0,15.528,15.527A15.545,15.545,0,0,0,210.036,86.593Zm0,25.2a9.668,9.668,0,1,1,9.668-9.668A9.679,9.679,0,0,1,210.036,111.788Z",
    transform: "translate(-194.508 -86.593)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6117",
    "data-name": "Group 6117",
    transform: "translate(69.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6116",
    "data-name": "Group 6116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4956",
    "data-name": "Path 4956",
    d: "M240.421,0a2.93,2.93,0,0,0-2.93,2.93V15.568a2.93,2.93,0,0,0,5.86,0V2.93A2.93,2.93,0,0,0,240.421,0Z",
    transform: "translate(-237.491)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6119",
    "data-name": "Group 6119",
    transform: "translate(86.225 10.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6118",
    "data-name": "Group 6118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4957",
    "data-name": "Path 4957",
    d: "M307,36.608a2.93,2.93,0,0,0-4.144,0l-7.716,7.715a2.93,2.93,0,0,0,4.144,4.143L307,40.752A2.93,2.93,0,0,0,307,36.608Z",
    transform: "translate(-294.287 -35.75)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6121",
    "data-name": "Group 6121",
    transform: "translate(45.239 10.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6120",
    "data-name": "Group 6120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4958",
    "data-name": "Path 4958",
    d: "M167.109,44.273l-7.716-7.715A2.93,2.93,0,0,0,155.25,40.7l7.716,7.715a2.93,2.93,0,1,0,4.143-4.143Z",
    transform: "translate(-154.392 -35.699)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6123",
    "data-name": "Group 6123",
    transform: "translate(37.795 90.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6122",
    "data-name": "Group 6122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4959",
    "data-name": "Path 4959",
    d: "M142.109,307.726H131.915a2.93,2.93,0,1,0,0,5.859h2.167v15.807a2.93,2.93,0,0,0,5.86,0V313.585h2.167a2.93,2.93,0,1,0,0-5.859Z",
    transform: "translate(-128.985 -307.726)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6125",
    "data-name": "Group 6125",
    transform: "translate(57.385 90.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6124",
    "data-name": "Group 6124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4960",
    "data-name": "Path 4960",
    d: "M216.982,328.61l-7.749-18.6a2.929,2.929,0,0,0-5.408,0l-7.749,18.6a2.93,2.93,0,0,0,5.409,2.254l.448-1.076h9.192l.448,1.076a2.93,2.93,0,0,0,5.409-2.254Zm-12.608-4.682,2.155-5.171,2.155,5.171Z",
    transform: "translate(-195.849 -308.211)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6127",
    "data-name": "Group 6127",
    transform: "translate(85.666 90.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6126",
    "data-name": "Group 6126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4961",
    "data-name": "Path 4961",
    d: "M304.9,320.021l5.058-7.778a2.93,2.93,0,0,0-4.912-3.194l-3.641,5.6-3.641-5.6a2.93,2.93,0,0,0-4.912,3.194l5.058,7.778-5.058,7.778a2.93,2.93,0,1,0,4.912,3.195l3.641-5.6,3.641,5.6a2.93,2.93,0,0,0,4.912-3.195Z",
    transform: "translate(-292.379 -307.716)",
    fill: "#ff725e"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxConsultancy);
export default __webpack_public_path__ + "static/media/tax_consultancy.4b799b4031d0cfe56ae9e8cb148e8256.svg";
export { ForwardRef as ReactComponent };